import type { ReactElement } from 'react'
import { PaperGrad, BeadyEye, STROKE, SHADOW, type GlyphProps } from './shared'

/* TIGER — sitting form, head pentagon with ears, tail flicked */
export const Tiger = ({ size = 110 }: GlyphProps): ReactElement => (
  <svg width={size} height={size} viewBox="0 0 120 120" style={SHADOW}>
    <defs>
      <PaperGrad id="tiger-l" light="#ffe2bf" dark="#ffbf80"/>
      <PaperGrad id="tiger-d" light="#ffbf80" dark="#d68a3a"/>
    </defs>
    {/* sitting body — folded triangle */}
    <polygon points="32,108 88,108 102,72 60,52 18,72" fill="url(#tiger-l)" stroke={STROKE} strokeWidth="2.2" strokeLinejoin="round"/>
    {/* shaded chest fold */}
    <polygon points="60,52 32,108 60,92" fill="url(#tiger-d)" opacity="0.7" stroke={STROKE} strokeWidth="0.8" strokeDasharray="2 2" strokeLinejoin="round"/>
    <line x1="60" y1="52" x2="60" y2="108" stroke={STROKE} strokeWidth="0.7" strokeDasharray="2 2"/>
    {/* tail flicked up-right */}
    <polygon points="88,108 110,68 100,92" fill="url(#tiger-d)" stroke={STROKE} strokeWidth="1.8" strokeLinejoin="round"/>
    {/* head — angular pentagon */}
    <polygon points="60,8 90,30 82,62 38,62 30,30" fill="url(#tiger-l)" stroke={STROKE} strokeWidth="2.2" strokeLinejoin="round"/>
    {/* ears */}
    <polygon points="30,30 22,8 44,24" fill="url(#tiger-l)" stroke={STROKE} strokeWidth="1.8" strokeLinejoin="round"/>
    <polygon points="90,30 98,8 76,24" fill="url(#tiger-l)" stroke={STROKE} strokeWidth="1.8" strokeLinejoin="round"/>
    <polygon points="30,30 28,16 38,22" fill="url(#tiger-d)" stroke={STROKE} strokeWidth="1" strokeLinejoin="round"/>
    <polygon points="90,30 92,16 82,22" fill="url(#tiger-d)" stroke={STROKE} strokeWidth="1" strokeLinejoin="round"/>
    {/* center crease on head */}
    <line x1="60" y1="8" x2="60" y2="62" stroke={STROKE} strokeWidth="0.7" strokeDasharray="2 2"/>
    {/* snout fold */}
    <polygon points="48,46 60,62 72,46 60,52" fill="url(#tiger-d)" opacity="0.6" stroke={STROKE} strokeWidth="0.8" strokeDasharray="2 2" strokeLinejoin="round"/>
    <BeadyEye cx={46} cy={36} r={2.2}/>
    <BeadyEye cx={74} cy={36} r={2.2}/>
    {/* nose */}
    <polygon points="60,52 56,56 64,56" fill={STROKE}/>
  </svg>
)
